"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ContentPage = _interopRequireDefault(require("./ContentPage"));
var _errors = require("./errors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ContentPages = _ref => {
  let {
    activePageName,
    children
  } = _ref;
  validateChildren(children);
  const activePage = _react.default.Children.toArray(children).find(child => child.props.name === activePageName);
  return activePage || null;
};
const validateChildren = children => {
  const expectedType = /*#__PURE__*/_react.default.createElement(_ContentPage.default, null).type;
  _react.default.Children.forEach(children, child => {
    if (child.type.name !== expectedType.name) {
      throw new _errors.ContentPageInvalidChildrenError(child.type.name);
    }
  });
};
ContentPages.propTypes = {
  activePageName: _propTypes.default.string.isRequired,
  children: _propTypes.default.node
};
var _default = exports.default = ContentPages;